// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SlanjeObavijesti_wrapper__UxZ\\+w {
  width: 90%;
}

form {
  display: flex;
  flex-direction: column;
  gap: 35px;
}

.SlanjeObavijesti_firstRow__Kd89G,
.SlanjeObavijesti_newRow__Jvhdc {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.SlanjeObavijesti_newRow__Jvhdc {
  justify-content: flex-start;
  gap: 5%;
}

.SlanjeObavijesti_item__MJ9Qt {
  display: flex;
  flex-direction: column;
  width: 30%;
  gap: 15px;
  background-color: transparent;
}

.SlanjeObavijesti_label__CJdwi {
  font-size: 15px;
  font-family: "Inter";
  font-weight: 600;
  color: #828d9a;
}

.SlanjeObavijesti_predmet__4ydxd {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.SlanjeObavijesti_predmetInput__uHpy0 {
  height: 46px;
  border-radius: 8px;
  padding: 0 15px;
  border: 1px solid #d8dbdf;
  font-size: 16px;
  font-family: "Inter";
  font-weight: 500;
  color: #9fa7b2;
  box-shadow: 0px 0px 40px 5px #5f6d7e1a;
  margin-bottom: 10px;
}

.SlanjeObavijesti_errorPredmetInput__hs4iF {
  height: 46px;
  border-radius: 8px;
  padding: 0 15px;
  border: 2px solid #cb2d2d;
  font-size: 16px;
  font-family: "Inter";
  font-weight: 500;
  color: #9fa7b2;
  box-shadow: 0px 0px 40px 5px #5f6d7e1a;
  margin-bottom: 10px;
}

.SlanjeObavijesti_errorText__sKdD5 {
  color: #cb2d2d;
  font-size: 15px;
  font-weight: 600;
}

.SlanjeObavijesti_predmetInput__uHpy0:focus {
  outline: none;
  border: #cb9c2d solid 2px;
}

.SlanjeObavijesti_predmetInput__uHpy0::placeholder {
  color: #9fa7b2;
}

.SlanjeObavijesti_btns__csOF5 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
}
.SlanjeObavijesti_btn1__7ra7V,
.SlanjeObavijesti_btn2__fv7-4 {
  width: 212px;
  height: 52px;
  font-size: 15px;
  font-family: "Inter";
  font-weight: 500;
  border: none;
  border-radius: 8px;
}

.SlanjeObavijesti_btn1__7ra7V:hover,
.SlanjeObavijesti_btn2__fv7-4:hover {
  cursor: pointer;
}

.SlanjeObavijesti_btn1__7ra7V {
  background-color: #ebebeb;
  color: #808080;
}

.SlanjeObavijesti_btn2__fv7-4 {
  background-color: #cb9c2d;
  color: #ffffff;
}

.SlanjeObavijesti_quill__RJ1lU {
  padding-top: 20px;
}

.SlanjeObavijesti_dropdown__3fC4p {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border: 1px solid #d8dbdf;
  height: 46px;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 16px;
  font-family: "Inter";
  font-weight: 500;
  color: #9fa7b2;
  box-shadow: 0px 0px 50px 5px #5f6d7e1a;
}

.SlanjeObavijesti_dropdown__3fC4p:focus {
  border: #cb9c2d solid 2px;
}

.SlanjeObavijesti_options__8LqMz,
.SlanjeObavijesti_optionsGpr__RfKm\\+ {
  width: 19.2%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  top: 240px;
  z-index: 2;
  border-radius: 8px;
  box-shadow: 3px 3px 20px 0px rgba(95, 109, 126, 0.1);
  background-color: #fff;
}

.SlanjeObavijesti_optionsGpr__RfKm\\+ {
  top: 100px;
  width: 30%;
}

.SlanjeObavijesti_option__v82B4 {
  font-size: 15px;
  font-family: "Inter";
  font-weight: 500;
  color: #9fa7b2;
  min-height: 46px;
  width: 100%;
  background-color: #ffffff;
  border: none;
  border-radius: 8px;
  text-align: start;
  padding-left: 15px;
}

.SlanjeObavijesti_option__v82B4:hover {
  background-color: #f2f2f2;
}

.SlanjeObavijesti_hidden__hzRHZ {
  visibility: hidden;
  position: absolute;
  width: 0px;
}

.SlanjeObavijesti_newRow__Jvhdc {
  visibility: visible;
  position: relative;
}

@media screen and (max-width: 1360px) {
  .SlanjeObavijesti_options__8LqMz {
    width: 18%;
  }
}

@media screen and (max-width: 1300px) {
  .SlanjeObavijesti_options__8LqMz,
  .SlanjeObavijesti_optionsGpr__RfKm\\+ {
    top: 270px;
    width: 24%;
    overflow: hidden;
    height: 230px;
  }
  .SlanjeObavijesti_optionsGpr__RfKm\\+ {
    top: 100px;
    height: fit-content;
    width: 30%;
  }
  .SlanjeObavijesti_dropdownScroll__AjLk\\+ {
    overflow: scroll;
    min-height: fit-content;
    width: 100%;
  }
}

@media screen and (max-width: 880px) {
  .SlanjeObavijesti_wrapper__UxZ\\+w {
    width: 100%;
  }
  .SlanjeObavijesti_item__MJ9Qt,
  .SlanjeObavijesti_optionsGpr__RfKm\\+ {
    width: 32%;
  }
  .SlanjeObavijesti_options__8LqMz {
    width: 28.5%;
  }

  .SlanjeObavijesti_newRow__Jvhdc {
    gap: 2%;
  }
}

@media screen and (max-width: 740px) {
  .SlanjeObavijesti_firstRow__Kd89G,
  .SlanjeObavijesti_newRow__Jvhdc {
    flex-direction: column;
    gap: 15px;
  }
  .SlanjeObavijesti_item__MJ9Qt {
    width: 100%;
  }
  .SlanjeObavijesti_options__8LqMz,
  .SlanjeObavijesti_optionsGpr__RfKm\\+ {
    position: relative;
    width: 100%;
    top: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/slanjeObavijesti/SlanjeObavijesti.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;;EAEE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,oDAAoD;EACpD,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;;IAEE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;;IAEE,kBAAkB;IAClB,WAAW;IACX,QAAQ;EACV;AACF","sourcesContent":[".wrapper {\n  width: 90%;\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  gap: 35px;\n}\n\n.firstRow,\n.newRow {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.newRow {\n  justify-content: flex-start;\n  gap: 5%;\n}\n\n.item {\n  display: flex;\n  flex-direction: column;\n  width: 30%;\n  gap: 15px;\n  background-color: transparent;\n}\n\n.label {\n  font-size: 15px;\n  font-family: \"Inter\";\n  font-weight: 600;\n  color: #828d9a;\n}\n\n.predmet {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.predmetInput {\n  height: 46px;\n  border-radius: 8px;\n  padding: 0 15px;\n  border: 1px solid #d8dbdf;\n  font-size: 16px;\n  font-family: \"Inter\";\n  font-weight: 500;\n  color: #9fa7b2;\n  box-shadow: 0px 0px 40px 5px #5f6d7e1a;\n  margin-bottom: 10px;\n}\n\n.errorPredmetInput {\n  height: 46px;\n  border-radius: 8px;\n  padding: 0 15px;\n  border: 2px solid #cb2d2d;\n  font-size: 16px;\n  font-family: \"Inter\";\n  font-weight: 500;\n  color: #9fa7b2;\n  box-shadow: 0px 0px 40px 5px #5f6d7e1a;\n  margin-bottom: 10px;\n}\n\n.errorText {\n  color: #cb2d2d;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.predmetInput:focus {\n  outline: none;\n  border: #cb9c2d solid 2px;\n}\n\n.predmetInput::placeholder {\n  color: #9fa7b2;\n}\n\n.btns {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 40px;\n}\n.btn1,\n.btn2 {\n  width: 212px;\n  height: 52px;\n  font-size: 15px;\n  font-family: \"Inter\";\n  font-weight: 500;\n  border: none;\n  border-radius: 8px;\n}\n\n.btn1:hover,\n.btn2:hover {\n  cursor: pointer;\n}\n\n.btn1 {\n  background-color: #ebebeb;\n  color: #808080;\n}\n\n.btn2 {\n  background-color: #cb9c2d;\n  color: #ffffff;\n}\n\n.quill {\n  padding-top: 20px;\n}\n\n.dropdown {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid #d8dbdf;\n  height: 46px;\n  border-radius: 8px;\n  padding: 0 10px;\n  font-size: 16px;\n  font-family: \"Inter\";\n  font-weight: 500;\n  color: #9fa7b2;\n  box-shadow: 0px 0px 50px 5px #5f6d7e1a;\n}\n\n.dropdown:focus {\n  border: #cb9c2d solid 2px;\n}\n\n.options,\n.optionsGpr {\n  width: 19.2%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  position: absolute;\n  top: 240px;\n  z-index: 2;\n  border-radius: 8px;\n  box-shadow: 3px 3px 20px 0px rgba(95, 109, 126, 0.1);\n  background-color: #fff;\n}\n\n.optionsGpr {\n  top: 100px;\n  width: 30%;\n}\n\n.option {\n  font-size: 15px;\n  font-family: \"Inter\";\n  font-weight: 500;\n  color: #9fa7b2;\n  min-height: 46px;\n  width: 100%;\n  background-color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  text-align: start;\n  padding-left: 15px;\n}\n\n.option:hover {\n  background-color: #f2f2f2;\n}\n\n.hidden {\n  visibility: hidden;\n  position: absolute;\n  width: 0px;\n}\n\n.newRow {\n  visibility: visible;\n  position: relative;\n}\n\n@media screen and (max-width: 1360px) {\n  .options {\n    width: 18%;\n  }\n}\n\n@media screen and (max-width: 1300px) {\n  .options,\n  .optionsGpr {\n    top: 270px;\n    width: 24%;\n    overflow: hidden;\n    height: 230px;\n  }\n  .optionsGpr {\n    top: 100px;\n    height: fit-content;\n    width: 30%;\n  }\n  .dropdownScroll {\n    overflow: scroll;\n    min-height: fit-content;\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 880px) {\n  .wrapper {\n    width: 100%;\n  }\n  .item,\n  .optionsGpr {\n    width: 32%;\n  }\n  .options {\n    width: 28.5%;\n  }\n\n  .newRow {\n    gap: 2%;\n  }\n}\n\n@media screen and (max-width: 740px) {\n  .firstRow,\n  .newRow {\n    flex-direction: column;\n    gap: 15px;\n  }\n  .item {\n    width: 100%;\n  }\n  .options,\n  .optionsGpr {\n    position: relative;\n    width: 100%;\n    top: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `SlanjeObavijesti_wrapper__UxZ+w`,
	"firstRow": `SlanjeObavijesti_firstRow__Kd89G`,
	"newRow": `SlanjeObavijesti_newRow__Jvhdc`,
	"item": `SlanjeObavijesti_item__MJ9Qt`,
	"label": `SlanjeObavijesti_label__CJdwi`,
	"predmet": `SlanjeObavijesti_predmet__4ydxd`,
	"predmetInput": `SlanjeObavijesti_predmetInput__uHpy0`,
	"errorPredmetInput": `SlanjeObavijesti_errorPredmetInput__hs4iF`,
	"errorText": `SlanjeObavijesti_errorText__sKdD5`,
	"btns": `SlanjeObavijesti_btns__csOF5`,
	"btn1": `SlanjeObavijesti_btn1__7ra7V`,
	"btn2": `SlanjeObavijesti_btn2__fv7-4`,
	"quill": `SlanjeObavijesti_quill__RJ1lU`,
	"dropdown": `SlanjeObavijesti_dropdown__3fC4p`,
	"options": `SlanjeObavijesti_options__8LqMz`,
	"optionsGpr": `SlanjeObavijesti_optionsGpr__RfKm+`,
	"option": `SlanjeObavijesti_option__v82B4`,
	"hidden": `SlanjeObavijesti_hidden__hzRHZ`,
	"dropdownScroll": `SlanjeObavijesti_dropdownScroll__AjLk+`
};
export default ___CSS_LOADER_EXPORT___;
